import firebase from '@/firebase';

const db = firebase.firestore();

// 出勤時の最適ルート
interface CpToWorkOutputState {
  id: string;
  createdAt: firebase.firestore.FieldValue;
  updatedAt: firebase.firestore.FieldValue;
}

const initialState: CpToWorkOutputState = {
  id: '',
  createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
};

const state = {
  cpToWorkOutputState: initialState,
};

const getters = {
  findFeasiblePathToWork: (state: any) => (weekday: string) =>
    state.cpToWorkOutputState[weekday],
  findFeasiblePathToWorkByServer: (state: any) => (
    weekday: string,
    serverId: string
  ) =>
    state.cpToWorkOutputState[weekday].feasiblePaths.find(
      (f: any) => f.server === serverId
    ),
  findFeasiblePathToWorkByClient: (state: any) => (
    weekday: string,
    clientId: string
  ) =>
    state.cpToWorkOutputState[weekday].feasiblePaths.find((f: any) =>
      f.clients.includes(clientId)
    ),
};

const mutations = {
  init: (state: any) => (state.cpToWorkOutputState = initialState),
  set: (state: any, payload: CpToWorkOutputState) =>
    (state.cpToWorkOutputState = payload),
};

const actions = {
  async getCpToWorkOutput({ commit }: any, payload: CpToWorkOutputState) {
    if (!payload.id) return;
    return await db
      .doc('organizations/' + payload.id + '/cpToWorkOutputs/' + payload.id)
      .get()
      .then((doc) => {
        if (!doc.exists) {
          commit('init');
          return null;
        }
        const data = Object.assign(
          {
            ref: doc.ref,
          },
          doc.data()
        );
        commit('set', data);
        return data;
      })
      .catch(() => {
        commit('init');
        return null;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
